<template>
  <div class="receipts">
    <div class="header">
      <h2>Számlák és bizonylatok</h2>
      <button v-if="canWrite" class="btn-primary" @click="showForm = !showForm">
        {{ showForm ? 'Mégse' : '+ Új számla' }}
      </button>
    </div>

    <div v-if="showForm && canWrite" class="form card">
      <input v-model="form.description" placeholder="Leírás (pl. Terembérlet)" class="modern-input" />
      <select v-model="form.category" class="modern-select">
        <option value="terembérlet">Terembérlet</option>
        <option value="egyéb">Egyéb</option>
      </select>
      <input v-model="form.date" type="date" class="modern-input" />
      <input v-model.number="form.amount" type="number" step="0.01" placeholder="Összeg (HUF)" class="modern-input" />
      <select v-if="isAdmin || isAssistant" v-model="form.teacher_id" class="modern-select">
        <option v-if="isAdmin" :value="String(userId)">Saját magam</option>
        <option value="">Tanár (opcionális)</option>
        <option v-for="t in teachers" :key="t.id" :value="t.id">
          {{ t.family_name }} {{ t.sure_name }}
        </option>
      </select>
      <select v-model="form.group_id" class="modern-select">
        <option value="">Csoport (opcionális)</option>
        <option v-for="g in groups" :key="g.id" :value="g.id">
          {{ g.name }}
        </option>
      </select>
      <div class="photo-upload">
        <label for="receiptFile" class="file-label">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14,2 14,8 20,8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
          </svg>
          <span>{{ form.image ? form.image.name : 'Kattints a bizonylat feltöltéshez' }}</span>
        </label>
        <input
          id="receiptFile"
          type="file"
          @change="onFile"
          accept="image/*,.pdf"
          class="file-input"
        />
      </div>
      <button class="btn-primary" @click="submit">Mentés</button>
    </div>

    <div class="summary card">
      <strong>Terembérlet összesen:</strong> {{ formatHuf(roomTotal) }}
    </div>

    <div v-if="loading" class="muted">Betöltés…</div>
    <table v-else class="tbl">
      <thead>
        <tr><th>Dátum</th><th>Leírás</th><th>Kategória</th><th>Összeg</th><th>Kapcsolódó tanár</th><th>Kapcsolódó csoport</th><th>Bizonylat</th><th v-if="canWrite"></th></tr>
      </thead>
      <tbody>
        <tr v-for="r in receipts" :key="r.id">
          <td>{{ r.date }}</td>
          <td>{{ r.description }}</td>
          <td>{{ r.category }}</td>
          <td>{{ formatHuf(r.amount) }}</td>
          <td>{{ r.teacher_name || '-' }}</td>
          <td>{{ r.group_name || '-' }}</td>
          <td>
            <a v-if="r.image_hash" :href="imgUrl(r.image_hash)" target="_blank">Megnyitás</a>
            <span v-else>-</span>
          </td>
          <td v-if="canWrite"><button class="btn-danger btn-sm" @click="remove(r.id)">Törlés</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ReceiptsItem',
  data() {
    return {
      receipts: [],
      teachers: [],
      groups: [],
      roomTotal: 0,
      loading: true,
      showForm: false,
      form: { description: '', category: 'terembérlet', date: '', amount: 0, teacher_id: '', group_id: '', image: null },
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isTeacher() {
      return this.$store.getters.isTeacher;
    },
    isAssistant() {
      return this.$store.getters.isAssistant;
    },
    userId() {
      return this.$store.getters.userId;
    },
    canWrite() {
      return this.isAdmin || this.isTeacher || this.isAssistant;
    },
    showTeacherSelect() {
      return this.isAdmin || this.isAssistant;
    }
  },
  mounted() {
    this.fetch();
    this.fetchTeachers();
    this.fetchGroups();
  },
  methods: {
    async fetch() {
      this.loading = true;
      try {
        const r = await axios.get(this.$BACKEND_HOST + '/api/receipts');
        this.receipts = r.data.receipts || [];
        this.roomTotal = r.data.room_rental_total || 0;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async fetchTeachers() {
      if (!this.isAdmin && !this.isAssistant) return;
      try {
        const r = await axios.get(this.$BACKEND_HOST + '/api/settings/teachers/info');
        this.teachers = r.data.teachers || [];
      } catch (e) { console.error(e); }
    },
    async fetchGroups() {
      try {
        const r = await axios.get(this.$BACKEND_HOST + '/api/settings/groups/info');
        this.groups = r.data.groups || [];
      } catch (e) { console.error(e); }
    },
    onFile(e) {
      this.form.image = e.target.files[0];
    },
    imgUrl(hash) {
      return this.$BACKEND_HOST + '/api/image/' + hash;
    },
    async submit() {
      const fd = new FormData();
      fd.append('description', this.form.description);
      fd.append('category', this.form.category);
      fd.append('date', this.form.date);
      fd.append('amount', this.form.amount);
      if (this.isTeacher && !this.isAdmin && !this.isAssistant) {
        fd.append('teacher_id', this.userId);
      } else if (this.form.teacher_id) {
        fd.append('teacher_id', this.form.teacher_id);
      }
      if (this.form.group_id) fd.append('group_id', this.form.group_id);
      if (this.form.image) fd.append('image', this.form.image);
      await axios.post(this.$BACKEND_HOST + '/api/receipts', fd);
      this.form = { description: '', category: 'terembérlet', date: '', amount: 0, teacher_id: '', group_id: '', image: null };
      this.showForm = false;
      this.fetch();
    },
    async remove(id) {
      await axios.delete(this.$BACKEND_HOST + `/api/receipts/${id}`);
      this.fetch();
    },
    formatHuf(v) {
      return (v || 0).toLocaleString('hu-HU') + ' HUF';
    },
  },
};
</script>

<style scoped>
.receipts { max-width: 1000px; margin: 0 auto; padding: 1.5rem; }
.header { display: flex; justify-content: space-between; align-items: center; }
.card { background: var(--card-bg); border: 1px solid var(--color-border); border-radius: 12px; padding: 1rem; margin-bottom: 1rem; }
.form { display: flex; flex-direction: column; gap: 0.6rem; }
.tbl { width: 100%; border-collapse: collapse; }
.tbl th, .tbl td { padding: 0.5rem; border-bottom: 1px solid var(--color-border); text-align: left; }
.summary { font-size: 1.05rem; }
.muted { color: var(--color-text-muted); padding: 1rem; }
.btn-primary { background: var(--button-primary); color: #fff; border: none; padding: 0.5rem 1rem; border-radius: 8px; cursor: pointer; }
.btn-danger { background: #d33; color: #fff; border: none; padding: 0.35rem 0.7rem; border-radius: 6px; cursor: pointer; }
.btn-sm { font-size: 0.8rem; }
.photo-upload {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  position: relative;
}
.file-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
  border: 2px dashed var(--color-border);
  border-radius: 10px;
  background: var(--color-background);
  color: var(--color-text-muted);
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.file-label:hover {
  border-color: var(--primary-blue);
  color: var(--primary-blue);
  background: var(--card-bg);
}
.file-label svg {
  flex-shrink: 0;
  opacity: 0.75;
}
.file-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}
</style>
